import React from 'react';
import { createStyles } from './styles';

const Footer = (): JSX.Element => {
  const classes = createStyles();
  const currentYear = new Date().getFullYear();
  return (
    <footer className={classes.footer}>
      <div className={classes.footerContent}>
        <p className={classes.copyright}>{`Copyright ® ${currentYear} InsuranceMenu Inc. All rights reserved.`}</p>
        <ul className={classes.links}>
          <li className={classes.linkItem}>
            <a href="https://home.insurancemenu.com/privacy-policy" rel="noreferrer" target="_blank">
              Privacy Policy
            </a>
          </li>
          <li className={classes.linkItem}>
            <a href="https://home.insurancemenu.com/terms-of-use" rel="noreferrer" target="_blank">
              Terms of Use
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
